@reference "~/styles.css";

@layer components {
	.alert {
		@apply flex gap-3 w-full rounded-sm border px-4 py-3 text-13 leading-5 text-gray-800;
	}

	.info {
		@apply bg-(--foundation-blue-100) border-(--foundation-blue-300);
	}

	.warning {
		@apply bg-orange-100 border-orange-300;
	}

	.error {
		@apply bg-red-100 border-red-300;
	}

	.success {
		@apply bg-green-100 border-green-300;
	}

	.icon {
		@apply shrink-0 text-xl/normal;

		:where(.info) & {
			@apply text-(--foundation-blue-500);
		}

		:where(.warning) & {
			@apply text-orange-500;
		}

		:where(.error) & {
			@apply text-red-500;
		}

		:where(.success) & {
			@apply text-green-500;
		}
	}
}
